<template>
  <q-dialog v-model="opened">
    <q-table
      title="Published Urls"
      :data="publishedIds"
      :columns="columns"
      :pagination.sync="pagination"
      :rows-per-page-options="[5]"
      :hide-bottom="publishedIds.length <= pagination.rowsPerPage"
      row-key="id">
      <q-td slot="body-cell-publishedAt" slot-scope="props" :props="props" >
        {{props.row.publishedAt.toLocaleString()}}
      </q-td>
      <q-td slot="body-cell-id" slot-scope="props" :props="props" >
        <router-link class="item item-link" :to="'/public/notes/' + props.row.id">
          {{props.row.id}}
        </router-link>
      </q-td>
      <q-td slot="body-cell-actions" slot-scope="props" :props="props" >
        <q-btn
          dense
          flat
          icon="delete"
          @click="deletePublishedURL(props.row)">
          <q-tooltip :offset="[0, 10]">Delete</q-tooltip>
        </q-btn>
      </q-td>
    </q-table>
    <q-btn @click="publish" class="q-ma-sm" flat color="primary">Publish</q-btn>
    <q-btn @click="close" class="float-right q-ma-sm" flat color="primary">Close</q-btn>
  </q-dialog>
</template>

<script>

export default {
  data () {
    return {
      name: '',
      noteHelper: null,
      opened: false,
      responsePromise: null,
      resolvePromise: null,
      rejectPromise: null,
      columns: [
        {
          name: 'publishedAt',
          required: true,
          label: 'Published At',
          align: 'left',
          field: 'publishedAt',
          sortable: true
        },
        {
          name: 'id',
          required: true,
          label: 'id',
          align: 'left',
          field: 'id',
          sortable: true
        },
        {
          name: 'actions',
          required: true,
          label: 'Actions',
          align: 'center',
          field: null,
          sortable: false
        }
      ],
      pagination: {
        sortBy: 'publishedAt', // String, column "name" property value
        descending: false,
        page: 1,
        rowsPerPage: 5 // current rows per page being displayed
      }
    }
  },
  computed: {
    publishedIds () {
      return ((this.noteHelper || {}).note || {}).publishedIds || []
    }
  },
  methods: {
    show (noteHelper) {
      this.opened = true
      this.noteHelper = noteHelper
      let t = this
      this.responsePromise = new Promise((resolve, reject) => {
        t.resolvePromise = resolve
        t.rejectPromise = reject
      })

      console.log(noteHelper.note.publishedIds[0])
      return this.responsePromise
    },

    close () {
      this.resolvePromise()
      this.opened = false
    },
    deletePublishedURL () {

    },
    publish () {
      let vm = this
      return vm.$q.dialog({
        title: 'Publish',
        message: 'Do you want to publish this note?',
        ok: true,
        cancel: true
      }).then(() => {
        return this.noteHelper.publish()
      }).then(() => {
        vm.$q.notify({
          message: 'Published Component!',
          type: 'positive'
        })
      }).catch((err) => {
        vm.$q.notify({
          message: 'Could not publish component. ' + err,
          type: 'negative'
        })
      }).then((response) => {
        return vm.$q.dialog({
          title: 'Note Published At',
          message: 'submind.io/public/notes/' + response.publishedId,
          cancel: 'Ok',
          ok: 'Delete!'
        })
      }).then(() => {
        return vm.$q.dialog({
          title: 'Delete',
          message: 'Are you sure you want to un-publish this note?' +
          'Others will then be unable to view it',
          ok: 'Delete',
          cancel: true
        })
      }).then((cancelled) => {
        if (cancelled) return
        vm.noteHelper.unpublish().catch((ex) => {
          vm.$q.notify('Unable to unpublish.')
          console.log(ex)
        })
      })
    }
  },
  mounted () {
    // let items = [1, 2, 3, 4, 5, 6]
    // items.forEach(i => {
    //   this.myArray.push({
    //     name: i,
    //     id: i
    //   })
    // })
  }
}
</script>

<style>
</style>
